"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTranslationsCommon = void 0;
exports.defaultTranslationsCommon = {
    en: {
        BRANDING_POWERED_BY_START: "Powered by ",
        BRANDING_POWERED_BY_END: "",
        SOMETHING_WENT_WRONG_ERROR: "Something went wrong. Please try again.",
    },
};
